<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: ['department', 'dateRange'],
  data() {
    return {
      sourcesData: [],
      totalQty: 0,
      chartSeries: [],
      chartOptions: {
        chart: {
          type: "donut",
          height: 240,
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "12px",
          labels: {
            colors: "#878a99"
          },
          markers: {
            width: 10,
            height: 10,
            radius: 5
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#3577f1", "#405189", "#0ab39c", "#f7b84b", "#f06548", "#299cdb", "#a95df6", "#f196b0"],
        stroke: {
          show: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: "Total",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#878a99",
                  formatter: (w) => {
                    return this.numberWithCommas(w.globals.seriesTotals.reduce((a, b) => a + b, 0));
                  }
                }
              }
            }
          }
        }
      }
    };
  },
  methods: {
    async getSourcesReport() {
      if (!this.dateRange || !this.dateRange.includes(" to ")) {
        return;
      }

      const data = {
        token: localStorage.getItem('jwt'),
        dateRange: this.dateRange,
        department: this.department
      };

      await axios
        .post('/api/management/reportSources', data)
        .then(response => {
          this.totalQty = 0;
          this.sourcesData = response.data;
          this.sourcesData.forEach((row) => this.totalQty += row.Qty);

          // Emit to parent
          this.$emit('update-total-agents', this.totalQty);

          // Build Chart Data
          const series = [];
          const labels = [];
          this.sourcesData.forEach(row => {
            series.push(row.Qty);
            labels.push(row.sourceName);
          });

          this.chartSeries = series;
          this.chartOptions = {
            ...this.chartOptions,
            labels: labels
          };
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout');
            }
            Swal.fire("Oops!", "Something went wrong, please contact your SysAdmin.", "error");
          }
        });
    },
    numberWithCommas(x) {
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x))
        x = x.replace(pattern, "$1,$2");
      return x;
    }
  },
  watch: {
    department: {
      handler() {
        this.getSourcesReport();
      }
    },
    dateRange: {
      handler() {
        this.getSourcesReport();
      }
    }
  },
  async mounted() {
    await this.getSourcesReport();
  }
};
</script>

<template>
  <div class="card card-height-100 border-0 shadow-sm rounded-3">
    <div class="card-header align-items-center d-flex border-0 bg-transparent pt-4 px-4 pb-0">
      <h4 class="card-title mb-0 flex-grow-1 fw-bold">Agents Added By Sources</h4>
    </div>

    <div class="card-body px-4">
      <div class="row align-items-center mb-4">
        <div class="col-12">
          <h6 class="text-muted text-uppercase fw-semibold text-truncate fs-12 mb-2">Total Agents Added</h6>
          <h4 class="fs-22 mb-0 fw-bold text-dark">{{ numberWithCommas(this.totalQty) }}</h4>
        </div>
      </div>

      <!-- Donut Chart -->
      <div class="mb-4" v-if="chartSeries.length > 0">
        <apexchart
          type="donut"
          height="240"
          :options="chartOptions"
          :series="chartSeries"
        ></apexchart>
      </div>
      <div v-else class="text-center py-5 bg-light rounded-3 mb-4">
        <i class="ri-pie-chart-line fs-32 text-muted mb-2 d-block"></i>
        <p class="text-muted mb-0 fs-13">No agent sources data available.</p>
      </div>

      <!-- Sources List -->
      <div class="pt-2 border-top border-light" v-if="sourcesData.length > 0">
        <div class="d-flex mb-3 align-items-center" v-for="(row, index) in this.sourcesData" :key="index">
          <div class="flex-grow-1">
            <p class="text-truncate text-muted fs-14 mb-0">
              <i class="mdi mdi-circle align-middle me-2" :style="{ color: chartOptions.colors[index % chartOptions.colors.length] }"></i>
              {{ row.sourceName }}
            </p>
          </div>
          <div class="flex-shrink-0 d-flex align-items-center text-dark fw-medium">
            <span>{{ row.Qty }}</span>
            <span class="text-muted fs-12 ms-2">({{ totalQty > 0 ? Math.round((row.Qty / totalQty) * 100).toFixed(2) : 0 }}%)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>